module.exports = __webpack_public_path__ + "img/Renovatie.aef304cc.svg";